export default "__VITE_ASSET__DznaE3f2__"